import React from 'react';
import { Input, Button, CheckboxTable, Select, PaperClip, WhatsAppButton } from 'components';
import { FormalityService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { ApprovedImage } from 'assets/img';

interface Props {
  onClose?: any;
  goToValidation?: any;
}

class ModalViewValidate extends React.Component<Props> {
  render() {
    return (
      <div id='modal-view-validate'>
        <div className='container-flex'>
          <div className='container-icon'>
            <img src={ApprovedImage} />
          </div>
          <div style={{ flex: 1 }}>
            <h4>Tu cuenta no está verificada</h4>
            <p>
              Para poder acceder a todos los servicios de la plataforma, debes subir tus documentos
              de verificación.
            </p>
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '12px',
            marginBottom: '20px',
          }}
        >
          <button className='btn-validate' onClick={() => this.props.goToValidation()}>
            1. Envíe sus documentos
          </button>
          <WhatsAppButton
            phoneNumber='584225342555'
            message='Hola, quiero agendar una cita para la verificación de mi cuenta en Legalmente.'
            buttonText='2. Agende cita para verificarlos'
            className='btn-whatsapp'
          />
        </div>
      </div>
    );
  }
}

export default ModalViewValidate;
